import { Option } from '@cmg/common';

import { InvestorContactSearch_InvestorContactPartsFragment } from './graphql/__generated__';

export type InvestorContactOption = Option<string | null>;

export const getContactsOptions = (
  contacts: readonly InvestorContactSearch_InvestorContactPartsFragment[]
) => {
  return contacts.map<InvestorContactOption>(contact => {
    const email = contact.email1 ?? contact.email2 ?? '';

    return {
      value: contact.investorEmployeeId,
      label: contact.name,
      email,
    };
  });
};
